import React from 'react'

export default function Footer() {
  return (
    <>
      <footer className="main-footer">
        <strong style={{ color: '#775DA8' }}>
          Gimmecomments | Admin Portal
        </strong>
        <div className="float-right d-none d-sm-inline-block">
          2023 © All rights reserved
        </div>
      </footer>
    </>
  )
}
